/**
 * @Description 组件 Layout 布局
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div class="view-page-box body-page-bg" :class="{main_max : navbarFlag}">

		<!-- 组件 AppHeader -->
		<AppHeader v-if="initFlag" />

		<!-- app-message start -->
		<div v-if="false" class="app-message-box">
			<!-- Messages -->
			<Messages v-if="initFlag" />
		</div>
		<!-- app-message end -->

		<!-- AppNavbar -->
		<AppNavbar v-if="initFlag" @navbarFlagChange="navbarFlagChange" />

		<!-- AppMain -->
		<AppMain v-if="initFlag" />

		<!-- 组件 数据监听 -->
		<SubWatchData v-if="initFlag" />

		<!-- 组件 视频播放器 -->
		<WebrtcPlayer v-if="initFlag" :layerId="webrtcPlayerId" />

		<!-- 授权 dialog start -->
		<WarrantDialog ref="warrantDialog" :publicKey="''" @storeLoginInfo="storeLoginInfo" />
		<!-- 授权 dialog end -->

		<!-- 选择项目 start -->
		<div class="chose-project-shadow" v-if="filters.visibleFlag">
			<div class="chose-project-box">

				<!-- 标题 start -->
				<div class="chose-project-tit">
					<span>请选择要进入的项目：</span>
					<!--<span class="chose-project-close" title="放弃登录" @click="cancleLogin">X</span>-->
				</div>
				<!-- 标题 end -->

				<!-- 内容 start -->
				<div class="chose-project-form">
					<!-- el-form start -->
					<el-form :inline="true" :model="filters" ref="filters">
						<!-- el-form-item start -->
						<el-form-item prop="currProjectId">
							<!-- 单选框 start -->
							<el-radio-group v-model="filters.currProjectId" @change="radioChange">
								<el-radio v-for="item in filters.projects" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
							</el-radio-group>
							<!-- 单选框 end -->
						</el-form-item>
						<!-- el-form-item end -->
					</el-form>
					<!-- el-form end -->
				</div>
				<!-- 内容 end -->

				<!-- 按钮 start -->
				<div class="chose-project-btns">
					<!--<el-button type="info" size="mini" @click="cancleLogin">放弃登录</el-button>-->
					<el-button type="primary" size="mini" plain @click="intoProject">进入项目</el-button>
				</div>
				<!-- 按钮 end -->

			</div>
		</div>
		<!-- 选择项目 end -->

		<!-- loading start -->
		<div class="loading-2-box" v-if="!initFlag">
			<img class="abs-center" alt="加载中" title="加载中..." src="@/static_dazzle/images/loading_2.gif">
			<div class="abs-center loading-text">加载中...</div>
		</div>
		<!-- loading end -->

	</div>
</template>

/* JS */
<script>
	// 接口
	import ApiOam from '@/request/api-oam';
	// API 报警 GNSS
	import ApiAlarmGNSS from '@/request/api-alarm-gnss';

	// 组件 AppHeader
	import AppHeader from '@/components_index/AppHeader';
	// 组件 AppNavbar
	import AppNavbar from '@/components_index/AppNavbar';
	// 组件 Messages
	import Messages from '@/components_index/AppMessage/Messages';
	// 组件 AppMain
	import AppMain from '@/components_index/AppMain';
	// 组件 数据监听
	import SubWatchData from '@/components/SubWatchData';
	// 组件 视频播放器
	import WebrtcPlayer from '@/components/WebrtcPlayer/WebrtcPlayer';
	// 组件 授权
	import WarrantDialog from '@/components_index/License/WarrantDialog';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
		name: "Layout",

		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
		components: {
			// 组件 AppHeader
			AppHeader,
			// 组件 AppNavbar
			AppNavbar,
			// 组件 Messages
			Messages,
			// 组件 AppMain
			AppMain,

			// 组件 数据监听
			SubWatchData,
			// 组件 视频播放器
			WebrtcPlayer,
			// 组件 授权
			WarrantDialog,
		}, // components

		/**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
		props: {

		}, // props

		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 是否展示mini菜单
				navbarFlag: false,

				// id 视频播放器
				webrtcPlayerId: 'layer_id_player-webrtc',

				// 免登录 加载完成
				initFlag: false,
				// query 参数
				queryParams: {},

				// 登录信息
				loginInfo: {},
				// 选择项目
				filters: {
					// 表单展示 flag
					visibleFlag: false,
					// 当前账户关联项目
					projects: [],
					// 当前项目
					currProjectId: '',
					// 当前项目name
					currProjectName: '',
					// 菜单类型
					showType: 2, // 1 运维 2 应用
				}, // filters

				// 交互锁
				locked_login: false,
				// 交互锁
				locked_isAuth: false,

			}
		}, // data

		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			// query 参数
			this.queryParams = Object.assign({}, this.$route.query);
			if(this.$checkEmpty(this.queryParams.accountId) && this.$checkEmpty(this.queryParams.ssoid)) {
				// 非免登录
				// 免登录 加载完成
				this.initFlag = true;
			} else {
				// 免登录 自动获取登录数据

				let ssoid = this.queryParams.accountId || this.queryParams.ssoid;
				// 自动登录
				this.requestLogin('', '', 1, ssoid);
			}
		}, // created

		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			window.$this = this;
			// 查询 报警类型
			this.searchAlarmStatus();
		}, // mounted

		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {

		}, // beforeDestroy

		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {

		}, // destroyed

		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 切换左侧菜单状态
			 * @Auth CC
			 * @Date 
			 */
			navbarFlagChange(navbarFlag) {
				this.navbarFlag = navbarFlag;
			},// navbarFlagChange
			/**
			 * @Des 登录请求
			 * @Auth
			 * @Date 
			 */
			requestLogin(usernameSecret, passwordSecret, type = 0, ssoid = '') {
				// 交互锁
				this.locked_login = true;
				// 打开登录锁，防止重复提交
				this.$request.postJsonRequest(ApiOam.Login_Uri, {
					"username": usernameSecret,
					"password": passwordSecret,
					type: type,
					ssoid: ssoid,
				}).then(result => {
					// 交互锁
					this.locked_login = false;
					// 关闭 loading
					this.loading && this.loading.close();

					// console.log(result)
					// 返回结果
					if(result.code == 0) {
						// 登录信息
						this.loginInfo = Object.assign({}, result.data);
						// 记录 uuid
						this.$store.dispatch("commitUuid", result.data.uuid);
						// 保存账户授权码、应用ID、语言
						this.$store.dispatch("commitToken", this.loginInfo.authCode);
						this.$store.dispatch("commitLoginDevice", this.loginInfo.loginDevice);
						this.$store.dispatch("commitLang", this.loginInfo.lang);

						// 项目信息
						if(this.queryParams.projectId && this.queryParams.projectId != undefined) {
							this.$store.dispatch("commitCurrentProjectId", this.queryParams.projectId);
						}
						if(this.queryParams.projectName && this.queryParams.projectName != undefined) {
							this.$store.dispatch("commitCurrentProjectName", this.queryParams.projectName);
						}

						this.usernameSecret = usernameSecret;
						this.passwordSecret = passwordSecret;

						// 用户关联项目
						const userProject = JSON.parse(result.data.userProject);
						// 初始化项目表单
						this.initProjects(this.$checkEmpty(userProject) ? [] : userProject);

					}
				}).catch(error => {
					// 交互锁
					this.locked_login = false;
					console.error('登录异常', ApiOam.Login_Uri, error);
				})
			}, // requestLogin

			/**
			 * @Des 初始化项目表单
			 * @Auth CC
			 * @Date 
			 */
			initProjects(_rows) {
				// 空值
				if(this.$checkEmpty(_rows)) {
					this.$message('账户未绑定项目');
					return false;
				}

				let rows = []; // 记录list数据
				// 检索 rows
				if(typeof _rows == 'string') {
					rows = JSON.parse(_rows);
				} else {
					rows = Object.assign([], _rows);
				}

				// 当前账户关联项目
				this.filters.projects = Object.assign([], rows);
				var exitFlag = false;
				if(this.$store.state.currentProjectId) {
					Object.assign([], rows).forEach((row, index) => {
						// projectId 匹配
						if(!exitFlag && this.$store.state.currentProjectId == row.id) {
							// 当前项目id
							this.filters.currProjectId = row.id;
							// 当前项目name
							this.filters.currProjectName = row.name;
							// 当前项目name
							this.filters.showType = row.showType;

							exitFlag = true;
						}
					});

					// projectId 不匹配
					if(!exitFlag) {
						// 当前项目id
						this.filters.currProjectId = rows[0]['id'];
						// 当前项目name
						this.filters.currProjectName = rows[0]['name'];
						// 当前项目name
						this.filters.showType = rows[0]['showType'];
					}

				} else {
					// 当前项目id
					this.filters.currProjectId = rows[0]['id'];
					// 当前项目name
					this.filters.currProjectName = rows[0]['name'];
					// 当前项目name
					this.filters.showType = rows[0]['showType'];
				}

				if(rows.length == 1 || (this.queryParams.projectId && exitFlag)) {
					// 进入项目
					this.intoProject();
					return false;
				}

				// 表单展示 flag
				this.filters.visibleFlag = true;

			}, // initProjects

			/**
			 * @Des 进入项目
			 * @Auth CC
			 * @Date 
			 */
			intoProject() {
				// 表单展示 flag
				this.filters.visibleFlag = false;

				if(this.loginInfo.isAuthorized == 1) {
					// 存储登录信息
					this.storeLoginInfo();
				} else {
					// 是否授权
					this.isAuth();
				}
			},// intoProject

			/**
			 * @Des 是否授权
			 * @Auth CC
			 * @Date 
			 */
			isAuth() {
				if(this.locked_isAuth) return false;

				// 交互锁
				this.locked_isAuth = true;
				this.$request.postJsonRequest(ApiOam.Is_Auth_Uri, {
					systemType: 2, // 1运维平台	2 应用平台
					projectId: this.filters.currProjectId,
				}).then(result => {
					// 交互锁
					this.locked_isAuth = false;
					// 关闭 loading
					this.loading && this.loading.close();

					// 返回结果
					if(result.code == 0) {
						// 存储登录信息
						this.storeLoginInfo();
					} else {
						// 授权弹窗
						this.$refs.warrantDialog.openDialog({
							projectId: this.filters.currProjectId,
							projectName: this.filters.currProjectName,
						});
					}
				}).catch(error => {
					// 交互锁
					this.locked_isAuth = false;

					console.error('查询授权权限异常', ApiOam.Is_Auth_Uri, error);
				})
			}, // isAuth

			/**
			 * @Des 存储登录信息
			 * @Auth 
			 * @Date 
			 */
			storeLoginInfo() {
				this.$store.dispatch("commitUserRole", this.loginInfo.userRole);
				this.$store.dispatch("commitUserName", this.loginInfo.userName);
				this.$store.dispatch("commitAccountId", this.loginInfo.accountId);
				this.$store.dispatch("commitAutoLogin", true);
				this.$store.dispatch("commitLoginIp", this.loginInfo.loginIp == null ? "" : this.loginInfo.loginIp);
				this.$store.dispatch("commitLoginKey", this.loginInfo.loginKey == null ? "" : this.loginInfo.loginKey);
				this.$store.dispatch("commitLoginCity", this.loginInfo.loginCity == null ? "" : this.loginInfo.loginCity);

				// uwb 继续记录
				this.$store.dispatch("commitAccount", this.loginInfo.account);
				this.$store.dispatch("commitUserProject", this.loginInfo.userProject);
				// this.$store.dispatch("commitUserArea", this.loginInfo.userArea);
				this.$store.dispatch("commitUserAdminRole", this.loginInfo.userAdminRole);
				this.$store.dispatch("commitIsAuthorized", this.loginInfo.isAuthorized); // this.loginInfo.isAuthorized

				// 记录资源路由
				this.$store.dispatch("commitUserRouter", JSON.stringify(['/manager/index']));

				// 记录当前项目
				this.$store.dispatch("commitCurrentProjectId", this.filters.currProjectId); // 记录当前项目 id
				this.$store.dispatch("commitCurrentProjectName", this.filters.currProjectName); // 记录当前项目 名称
				this.$store.dispatch("commitShowType", this.filters.showType); // 记录当前项目 名称

				// 免登录 加载完成
				this.initFlag = true;
			}, // storeLoginInfo

			/**
			 * @Des 选项改变
			 * @Auth CC
			 * @Date 
			 */
			radioChange() {
				// 空值
				if(this.$checkEmpty(this.filters.currProjectId)) {
					// 当前项目name
					this.filters.currProjectName = '';
					this.filters.showType = '';
					return false;
				}

				// 记录 rows
				const rows = Object.assign([], this.filters.projects);
				// 遍历
				rows.forEach((row, index) => {
					// 空值 跳过
					if(this.$checkEmpty(row) || this.$checkEmpty(row.id) || this.$checkEmpty(row.name)) {
						return true;
					}

					// 匹配项目id
					if(this.filters.currProjectId == row.id) {
						// 当前项目name
						this.filters.currProjectName = row.name;
						this.filters.showType = row.showType;
					}

				});

			}, // radioChange

			/**
			 * @Des 查询 报警类型
			 * @Auth CC
			 * @Date 
			 */
			searchAlarmStatus() {
				this.$request.postJsonRequest(ApiAlarmGNSS.findAlarmStatusApi, {}).then(result => {
					// console.log(result)
					let alarmStatus = Object.assign({}, {});
					if(result.code == 0) {
						alarmStatus = Object.assign({}, result.data);
					}
					
					// 记录 报警类型
					this.$store.dispatch('commitAlarmStatus', JSON.stringify(alarmStatus)); // 记录当前项目 id
				}).catch(error => {
					console.log('查询报警状态异常', error);
				})
			}, // searchAlarmStatus

		}, // methods

		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {

		}, // watch

		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {

		}, // computed

	} // export default
</script>

/* CSS */
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components_index/Layout.vue